import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid--horizontal" }
const _hoisted_2 = {
  class: "grid__cell",
  style: { width: '50%' }
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Open ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Close ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Read ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Write ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Send request ")
const _hoisted_8 = {
  class: "grid__cell",
  style: { width: '50%' }
}
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_card, { header: "Request" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            ref: "form",
            "label-width": "120px",
            "label-position": "left",
            size: "small",
            model: _ctx.options
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Port" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.options.port,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.options.port) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Type" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.options.type,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.options.type) = $event)),
                    placeholder: _ctx.trans('label.nothing-selected'),
                    "automatic-dropdown": false,
                    filterable: "",
                    "allow-create": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "RFID",
                        value: "rfid"
                      }),
                      _createVNode(_component_el_option, {
                        label: "QR Code 1",
                        value: "qrcode1"
                      }),
                      _createVNode(_component_el_option, {
                        label: "QR Code 2",
                        value: "qrcode2"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Query" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.options.query,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.options.query) = $event)),
                    type: "textarea",
                    rows: 15
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setQuery('open')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setQuery('close')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setQuery('read')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setQuery('write')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.sendRequest
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_el_card, { header: "Response" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            ref: "form",
            "label-width": "120px",
            "label-position": "left",
            size: "small",
            model: _ctx.result
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "URL" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.result.url,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.result.url) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Result" }, {
                default: _withCtx(() => [
                  _createElementVNode("pre", {
                    class: "debug__result--response",
                    innerHTML: _ctx.result.response
                  }, null, 8, _hoisted_9)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      })
    ])
  ]))
}